module.exports = __webpack_public_path__ + "static/106e8513.man.png";